export default "__VITE_ASSET__9ec916b6__"